import { ResolveFn } from "@angular/router";
import { inject } from "@angular/core";
import { StockTypeApiService } from "../services/stock-type-api.service";
import { IStockType } from "@app/shared/settings/stock-type/interfaces/stock-type.interface";

export const getStockTypeResolver: ResolveFn<IStockType> = (route, _) => {
  const stockTypeService = inject(StockTypeApiService);

  return stockTypeService.getStockType(route.paramMap.get("id")!);
};
